import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import PersonDetails from "@/shared/model/personDetails";
import {ref, watch} from "vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
interface Props {
  details?:PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonBankverbindungFormComponent',
  props: {
    details: { default: undefined }
  },
  setup(__props: any, { expose: __expose }) {

const _form = ref<InstanceType<typeof SogForm>  | null>(null)
const  props = __props

const _iban = ref<string|undefined>(undefined)
const _bic = ref<string|undefined>(undefined)
const _bank = ref<string|undefined>(undefined)
function validate():boolean{
  return _form.value?.validate()??false;
}

watch(props,()=>{
  _iban.value = props.details?.getValue(PersonDetailsId.Iban)
  _bic.value = props.details?.getValue(PersonDetailsId.Bic)
  _bank.value = props.details?.getValue(PersonDetailsId.Bank)

},{immediate:true})

function getDetailsBank():PersonDetails|undefined{
  if(!validate()) return undefined;
  const details = new PersonDetails(props?.details?.getValues());
  details.setValue(PersonDetailsId.Iban,_iban.value)
  details.setValue(PersonDetailsId.Bic,_bic.value)
  details.setValue(PersonDetailsId.Bank,_bank.value)
  return details;
}

__expose({
  validate,
  getDetailsBank
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form
  }, {
    default: _withCtx(() => [
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _iban.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_iban).value = $event)),
            placeholder: "IBAN",
            name: "IBAN"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _bic.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_bic).value = $event)),
            placeholder: "BIC",
            name: "BIC"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _bank.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_bank).value = $event)),
            placeholder: "Bank",
            name: "Bank"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})